import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Dropzone from 'react-dropzone'
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class CfdiUploadForm extends Component {
    constructor() {
        super();
        this.state = {
            file:'',
            failed:false,
            data:[],
            filesdata:[],
            dropzoneEnabled: false,
        };
    }
    async componentDidMount() { 
        this.getProccesedCfdis()
    }
    enableDropzone = () => { 
        this.setState({ dropzoneEnabled: true });
    };

    onDrop = (acceptedFiles)=>{ 
        this.setState({ file: acceptedFiles[0] });
        
        let formData = new FormData()
        formData.append('file',acceptedFiles[0])
        formData.append('document_id',this.props.document_id)
        formData.append('person_provider_id',this.props.person_provider_id)
        formData.append('is_automatic',0)
        formData.append('internals',0)
        let that = this
        axios.post( '/api/uploadDocument',formData ).then((res) => {
            swal.fire({
                text: getSuccessMessage(res),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {  
                window.location.href= '/document_dossier/'+that.props.person_provider_id+'/review_file/'+that.props.document_id 
            });
        }).catch((error) => { 
            const message = getErrorsMessage(error);
            this.setState({'failed':true }) 
            if (  error.response.data.data) { 
                this.setState({ 'data': error.response.data.data });
            }
            if (  error.response.data.filesdata) { 
                this.setState({ 'filesdata': error.response.data.filesdata });
            }
            
            KTUtil.btnRelease(KTUtil.getById('btnSubmit'));
            swal.fire({
                html: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        })
    } 
    render() {
        return (
            <div className='card-body'> 
                <div class="d-flex justify-content-between">
                    <h5 class="text-dark font-weight-bold my-1 mb-10">
                        {this.props.title} 
                        <br></br>
                    <small class="text-muted font-weight-bold">Mis Documentos  </small>
                    </h5> 
                </div>
                <div class="form-group row">
                    <div class="col-md-3 text-md-right"> Plantilla </div>
                    <div class="col-md-9">
                        <a href='/assets/media/template/PlantillaCfdiExppedify.xlsx' onClick={this.enableDropzone}  >Descargar plantilla base</a>
                    </div>
                    <div class="col-md-3 text-md-right mt-5">
                        Instrucciones de llenado de plantilla
                    </div>
                    <div class="col-md-9 mt-5">
                    1. Descargar la plantilla base y llenar los datos requeridos. <br></br>
                    2. Crear un archivo ZIP que contenga la plantilla .XLS junto con el número de archivos XMLs correspondientes al RFC y periodo que se especifica en la plantilla base.<br></br> 
                    3. Asegurarse que el ZIP contenga un archivo .XLS y los archivos de tipo .XML juntos, sin subcarpetas.  <i data-toggle="modal" data-target="#modal" class="flaticon-questions-circular-button icon-sm"></i><br></br>
                    4. Los archivos .XML deberán ser de tipo de CFDI solicitado.
                    </div>
                    <div class="modal fade" id="modal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">
                        <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
                            <div class="modal-content"  >
                                <div class="modal-body p-15">
                                    <div className='d-flex flex-column'>
                                        <img src="/img/subfolders.png"></img>
                                        <button type="button" class="btn  mt-3 btn-primary btn-block " data-dismiss="modal"> Aceptar </button> 
                                    </div> 
                                </div> 
                            </div>
                        </div>  
                    </div>
                    
                    <div class="col-md-3 text-md-right mt-5">
                        Validación de tipo de archivo
                    </div>
                    <div class="col-md-9 mt-5">
                        <Dropzone onDrop={this.onDrop} accept=".zip" disabled={!this.state.dropzoneEnabled} >
                            {({getRootProps, getInputProps}) => (
                                <section className="  mb-6">
                                    <div {...getRootProps({className: 'cfdiDrop'})}>
                                    <input {...getInputProps()} />
                                    {this.state.dropzoneEnabled ? (
                                        <p>Suelta los archivos aquí o haz clic para subirlos.</p>
                                    ) : (
                                        <p>Para continuar, es necesario que descargues la plantilla base</p>
                                    )}
                                    {this.state.successFile == true ? <div class="alert alert-success" role="alert">El archivo se ha subido correctamente y no contiene errores</div> : null}
                                    </div>
                                </section>
                            )}
                        </Dropzone>
                    </div>
                </div>  
            {(this.state.failed ) &&  
            <div className="alert alert-soft-warning mt-3 mb-3 d-flex align-items-center" role="alert"> 
                <div className='row'>
                <div className='col-md-12'>
                    <span className="flaticon2-warning mr-2 icon-3x"></span>
                </div>  
                    <div className='col-md-12'>
                    {this.state.data.length > 0 &&
                    <table className="table alert-soft-warning">
                    <thead>
                        <tr>
                            <th>Fila</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                    {this.state.data.map(item => (
                        <tr key={item.index}>
                            <td>{item.index}</td>
                            <td>{item.message}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                } 
                    </div>
                    <div className='col-md-12'>
                        <h5>Información de los archivos cfdi cargados en el zip  </h5> 
                    {this.state.filesdata.length > 0 &&
                    <table className="table alert-soft-warning">
                    <thead>
                        <tr>
                            <th>Nombre de archivo</th>
                            <th>Emisor</th>
                            <th>Receptor</th>
                            <th>Mes </th>
                            <th>Año</th>
                        </tr>
                    </thead>
                    <tbody>
                    {this.state.filesdata.map(item => (
                        <tr  >
                              <td>{item.filename}</td>
                            <td>{item.emisor}</td>
                            <td>{item.receptor}</td>
                            <td>{item.month}</td>
                            <td>{item.year}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                } 
                    </div>
                </div>
               

             
            </div>
            }
            </div>
        )
    }
}

export default CfdiUploadForm;

if (document.getElementById('CfdiUploadForm')) {
    ReactDOM.render(<CfdiUploadForm/>, document.getElementById('CfdiUploadForm'));
}
